import type { FC } from "react";

import type { TextBlock as TTextBlock } from "~/core";
import { Text } from "~/shared/ui-kit";

export type TextBlockProps = { data: TTextBlock };

export const TextBlock: FC<TextBlockProps> = ({ data }) => {
  return <Text content={data?.content ?? ""} />;
};
